module.exports = {
      id: "share-usage",
      viewBox: "0 0 13 13",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#share",
      toString: function () {
        return this.url;
      }
    }